// extracted by mini-css-extract-plugin
export var buttonContent = "_2s-0";
export var centered = "_2s-1";
export var centeredFlex = "_2s-2";
export var errorText = "_2s-3";
export var icon = "_2s-4";
export var iconButtonContent = "_2s-5";
export var monospace = "_2s-6";
export var padded = "_2s-7";